
//Angular
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';


//Servicios
import {DataService} from './dataservice.service';
import { AuthGuard } from './auth10/shared/guard/auth.guard';
import { AuthService } from './auth10/shared/services/auth.service';
import { AuthInterceptor } from './auth10/shared/services/auth.interceptor';

//Modulos




//Componentes
import { AppComponent } from './app.component';
import { SignInComponent } from './auth10/components/sign-in/sign-in.component';
import { SignUpComponent } from './auth10/components/sign-up/sign-up.component';
import { IndexComponent } from './auth10/components/index/index.component';
import { LogOutComponent } from './auth10/components/log-out/log-out.component';
import { SignUpUserComponent } from './auth10/components/sign-up-user/sign-up-user.component';
import { VerifyEmailComponent } from './auth10/components/verify-email/verify-email.component';
import { ForgotPasswordComponent } from './auth10/components/forgot-password/forgot-password.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { VerifySmsComponent } from './auth10/components/verify-sms/verify-sms.component';








@NgModule({
  declarations: [
  AppComponent,
  SignInComponent,
  SignUpComponent,
  IndexComponent,
  LogOutComponent,
  SignUpUserComponent,
  VerifyEmailComponent,
  ForgotPasswordComponent,
  VerifySmsComponent,

 
 


  
  

  ],

  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
  
	


  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  
  providers: [

    DataService,
    AuthGuard,
    AuthService,
    JwtHelperService,
    {  provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
   },
   { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
   {provide: LocationStrategy, useClass: HashLocationStrategy},
   
  ],
  
  bootstrap: [AppComponent]
    
})
export class AppModule { }
